exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".makereservationform .control-label{text-align: left}\n.input-group-addon{position: absolute; right: 0; top: 0; height: 30px; width: 30px; float:left; z-index: 9}\nlabel.error{font-weight:normal!important}\n.input-group{width: 180px!important;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/bussinesshours/bussinesshours.component.css
// module id = ../../../../../src/app/bussinesshours/bussinesshours.component.css
// module chunks = main